import { shouldSkipSSI } from '../../../pairing/pairing.utils';
import { getStatus as getSingleSignInStatus } from '../../../../logic/pairing/platform/default';

export const shouldNavigateToSingleSignIn = async () => {
  if (shouldSkipSSI()) {
    return false;
  }

  try {
    const { status } = await getSingleSignInStatus();

    return status.isPartnerLoginAllowed && status.displayTos;
  } catch (error) {
    return false;
  }
};
